// apps/einstein/src/components/Sidebar/TopMenu/SamCartTopMenu.tsx
import * as React from "react";
import { Box, List, useTheme } from "@mui/material";
import { Await, NavLink, useRouteLoaderData } from "react-router-dom";
import type { RootLoader } from "@/types/RootLoader";
import { useMainMenu } from "../helpers";
import ProfileMenu from "../../ProfileMenu";

function SamCartTopMenu() {
  const { accountInfo } = useRouteLoaderData("root") as RootLoader;
  const mainMenu = useMainMenu();
  const theme = useTheme();

  return (
    <Box
      component="nav"
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      px={4}
      sx={{
        background: theme.palette.background.default,
        top: 0,
        position: "sticky",
        zIndex: theme.zIndex.appBar,
        height: "48px",
      }}
    >
      <List
        sx={{
          display: "flex",
          gap: 1,
          flexDirection: "row",
          padding: 0,
          margin: 0,
        }}
      >
        {mainMenu.map((menuItem) => (
          <NavLink
            key={menuItem.name}
            to={menuItem.to}
            style={{ textDecoration: "none" }}
          >
            {({ isActive }) => (
              <Box
                sx={{
                  px: "24px",
                  py: 0,
                  height: "48px",
                  display: "flex",
                  alignItems: "center",
                  borderRadius: "8px",
                  fontSize: "14px",
                  fontWeight: 500,
                  lineHeight: "16px",
                  color: theme.palette.text.primary,
                  background: isActive
                    ? theme.palette.primary.light
                    : "transparent",
                  border: `1px solid ${
                    isActive ? theme.palette.primary.light : "transparent"
                  }`,
                  transition: "background 150ms ease, border-color 150ms ease",
                  "&:hover": {
                    background: theme.palette.primary.light,
                    borderColor: theme.palette.primary.light,
                  },
                  cursor: "pointer",
                }}
              >
                {menuItem.name}
              </Box>
            )}
          </NavLink>
        ))}
      </List>

      <Box display="flex" gap={3} alignItems="center">
        <React.Suspense>
          <Await resolve={accountInfo}>
            <ProfileMenu collapsed />
          </Await>
        </React.Suspense>
      </Box>
    </Box>
  );
}

export default SamCartTopMenu;
